module.exports = __webpack_public_path__ + "static/media/loader.19575687.svg";